'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/input-number/style/css');

var _inputNumber = require('antd/lib/input-number');

var _inputNumber2 = _interopRequireDefault(_inputNumber);

var _css2 = require('antd/lib/form/style/css');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 修改订单价格按钮及弹出表单
                                                                                                                                                                                                                                                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _modal_form = require('./modal_form');

var _modal_form2 = _interopRequireDefault(_modal_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;

var OrderChangePrice = _react2.default.createClass({
    displayName: 'OrderChangePrice',
    onOk: function onOk(form) {

    },
    render: function render() {
        var _props = this.props,
            order = _props.order,
            form = _props.form;
        var getFieldDecorator = form.getFieldDecorator;

        var formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 }
        };
        return _react2.default.createElement(
            _modal_form2.default,
            { form: form, title: '\u4FEE\u6539\u4EF7\u683C', onOk: this.onOk.bind(this, form) },
            _react2.default.createElement(
                _form2.default,
                null,
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { label: '\u5546\u54C1\u8D39\u7528\uFF1A' }),
                    _react2.default.createElement(
                        'span',
                        null,
                        order.product_fee
                    )
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { label: '\u8FD0\u8D39\uFF1A' }),
                    _react2.default.createElement(
                        'span',
                        null,
                        order.shipping_fee
                    )
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { label: '\u4F18\u60E0\uFF1A' }),
                    _react2.default.createElement(
                        'span',
                        null,
                        order.discount_fee
                    )
                ),
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { extra: '\u8F93\u5165\u4E3A0\u5143\u65F6\u6B64\u8BA2\u5355\u514D\u8D39', required: true, label: '\u4FEE\u6539\u4EF7\u683C\u4E3A\uFF1A' }),
                    getFieldDecorator('price', {
                        rules: [{ required: true, message: '请输入修改后的价格!' }]
                    })(_react2.default.createElement(_inputNumber2.default, null))
                )
            )
        );
    }
});

exports.default = _form2.default.create()(OrderChangePrice);


//////////////////
// WEBPACK FOOTER
// ./src/js/components/order_change_price.js
// module id = 1193
// module chunks = 0